export const defaultVoicemailModuleConfig = {
  voicemailEmail: "",
};
